import React, { useState } from 'react';
import { Box, IconButton, Dialog, DialogContent, CircularProgress, Typography } from '@mui/material';
import PlayCircleIcon from '@mui/icons-material/PlayCircle';
import CloseIcon from '@mui/icons-material/Close';

const VideoExplanationPlayer = ({ videoUrl, questionText, variant = 'button' }) => {
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(true);

  if (!videoUrl) return null;

  const handleOpen = () => setOpen(true);
  const handleClose = () => {
    setOpen(false);
    setLoading(true);
  };

  return (
    <>
      {variant === 'link' ? (
        <Typography
          component="span"
          onClick={handleOpen}
          variant="body2"
          color="primary"
          sx={{
            textDecoration: "underline",
            cursor: "pointer",
            display: "inline-flex",
            alignItems: "center",
            gap: 0.5
          }}
        >
          <PlayCircleIcon fontSize="small" />
          Watch explanation video
        </Typography>
      ) : (
        <IconButton onClick={handleOpen} color="primary" size="small" title="Watch explanation video">
          <PlayCircleIcon /> <Typography variant="caption" sx={{ ml: 0.5 }}>Watch Video</Typography>
        </IconButton>
      )}

      <Dialog
        open={open}
        onClose={handleClose}
        maxWidth="md"
        fullWidth
        PaperProps={{
          sx: {
            maxHeight: '90vh',
          }
        }}
      >
        <IconButton
          onClick={handleClose}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            zIndex: 1,
            bgcolor: 'rgba(0, 0, 0, 0.5)',
            color: 'white',
            '&:hover': {
              bgcolor: 'rgba(0, 0, 0, 0.7)',
            }
          }}
        >
          <CloseIcon />
        </IconButton>
        <DialogContent sx={{ p: 0, position: 'relative', bgcolor: 'black' }}>
          {loading && (
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                p: 4,
                minHeight: '300px'
              }}
            >
              <CircularProgress />
            </Box>
          )}
          <video
            controls
            autoPlay
            style={{
              width: '100%',
              maxHeight: '70vh',
              display: loading ? 'none' : 'block'
            }}
            onLoadedData={() => setLoading(false)}
            onError={() => {
              setLoading(false);
              console.error('Error loading video');
            }}
            title={questionText || 'Explanation video'}
          >
            <source src={videoUrl} type="video/mp4" />
            Your browser does not support the video tag.
          </video>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default VideoExplanationPlayer;
